import sparkles from '../../../assets/icons8-sparkle-24.png';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { useAuth } from '../../../contexts/AuthContext';
import { useEffect } from 'react';

function SubscriptionModal({ isOpen, onRequestClose, stripePromise, user }) {
    const stripe = useStripe();
    const elements = useElements();
    const { authToken } = useAuth();
    const userEmailAddress = user.email;
    const subscription = user.subscription === 1 ? 'Pro 🧡' : "Not subscribed";
    const credits = user.credits;
    const totalCredits = user.subscription === 1 ? 50 : 0;

    useEffect(() => {
        window.gtag_report_conversion = function(url) {
            var callback = function () {
                if (typeof(url) !== 'undefined') {
                    window.location = url;
                }
            };
            window.gtag('event', 'conversion', {
                'send_to': 'AW-10893931514/De1sCKCOi7AZEPrn0Moo',
                'event_callback': callback
            });
            return false;
        };
    }, []);
    
    if (!isOpen) {
        return null;
    }

    const handleCheckout = async () => {
        if (!stripe || !elements) return;
        try {
            const response = await fetch('/create-checkout-session', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
                body: JSON.stringify({
                    userEmailAddress
                })
            });
            const session = await response.json();

            const result = await stripe.redirectToCheckout({ sessionId: session.id });

            if (result.error) {
                console.error(result.error.message);
            }
            window.gtag_report_conversion();
        } catch (error) {
            console.error("Checkout error:", error);
        }
    };

    return (
        <>
            <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onRequestClose} />
            <dialog id="my_modal_3" className="modal" open>
                <div className="modal-box rounded-none bg-white">
                    <form method="dialog">
                        <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" onClick={onRequestClose}>✕</button>
                    </form>
                    <h3 className="font-bold text-lg">Manage subscription</h3>
                    <div className="p-2 pt-12">
                        <p className="">Your current subscription:</p>
                    </div>
                    <div className="p-2">
                        <p className="font-semibold text-3xl">{subscription}</p>
                    </div>
                    <div className="p-2 pb-6">
                    <p className="">
    {/* {user.subscription === 1 &&  */}
        <span>You have <b>{credits} of {totalCredits} credits remaining.</b></span>
    {/* } */}
    {user.subscription !== 1 && 
        <span> Subscribe to unlock everything CopyBuddy has to offer.</span>
    }
</p>
                    </div>
                    <div className="w-full flex justify-center items-center space-x-4">
                        {user.subscription !== 1 && (
                            <button
                                type="button"
                                onClick={handleCheckout}
                                className="flex items-center mb-3 rounded-full bg-custom-orange px-4 py-2.5 text-md font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                            >
                                <img src={sparkles} alt="sparkles" className="w-5 inline-block transform -translate-y-0.5" />&nbsp;&nbsp;Subscribe
                            </button>
                        )}
                        {user.subscription === 1 && (
  <p className="py-4">To cancel your subscription or update your payment method, please email adamgusky1@gmail.com</p>
)}
                    </div>
                </div>
            </dialog>
        </>
    );
}

export default SubscriptionModal;